import { render, staticRenderFns } from "./second_videoList.vue?vue&type=template&id=63bccaed&scoped=true&"
import script from "./second_videoList.vue?vue&type=script&lang=js&"
export * from "./second_videoList.vue?vue&type=script&lang=js&"
import style0 from "./second_videoList.vue?vue&type=style&index=0&id=63bccaed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bccaed",
  null
  
)

export default component.exports